module.exports = __webpack_public_path__ + "media/images/japan/tips_2-9b77104af46925c20d7d3dbbe1f2cd99.jpg";